var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecicle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2774 8.51389C18.8874 6.11438 16.2895 4.5 13.314 4.5C9.94035 4.5 7.05209 6.57535 5.85956 9.51736M17.8358 9.51736H21.8552V5.50347M6.4331 16.5417C7.82304 18.9412 10.421 20.5556 13.3964 20.5556C16.7701 20.5556 19.6584 18.4802 20.8509 15.5382M8.87462 15.5382H4.85523V19.5521",
    stroke: "#265DAF ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecicle);
export default __webpack_public_path__ + "static/media/recicle.3a2bb01da7ea9361dbd61ae4b353b0ec.svg";
export { ForwardRef as ReactComponent };